// Getter Object for Shop_groupsDistribution. Use it by calling mapGetters from the Vuex Host Components.

export const shop_groupsDistributionGetters = {
  shop_groupsData: state => state.shop_groupsData,
  shop_groupList: state => state.shop_groupList,
  shop_groupDetails: state => state.shop_groupDetails
};
